import { Controller } from 'react-hook-form';

import Field from 'ui/Field';
import Slider, { SliderProps } from 'ui/Slider';
import { useUpstreamFormPropagation } from 'utils/form';

import { useSankeyFormContext } from '../../contexts/sankeyFormContext';
import {
  getFieldMaxConstraint,
  getFieldMinConstraint,
} from '../../utils/validation';

type Props = SliderProps & {
  field: SankeyFormNumericField;
  label?: string;
};

const FormSlider = ({ field, label, step = 1, ...rest }: Props) => {
  const { form } = useSankeyFormContext();

  // Propagate the slider value after 200ms to avoid too many re-renders while dragging.
  useUpstreamFormPropagation(field, 200);

  return (
    <Controller
      name={field}
      control={form.control}
      render={({ field }) => (
        <Field label={label} fontSize="xs">
          <Slider
            value={[Number(field.value) ?? undefined]}
            onValueChange={(e) => field.onChange(e.value[0])}
            min={getFieldMinConstraint(field.name)}
            max={getFieldMaxConstraint(field.name)}
            step={step}
            size="sm"
            w="100%"
            {...rest}
          />
        </Field>
      )}
    />
  );
};

export default FormSlider;
